module.exports = __webpack_public_path__ + "static/img/eboard-factory-new.d434e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eboard-factory-new.png
// module id = Clwl
// module chunks = 1